import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../../config';
import SaveButton from '../../../../commons/Buttons/SaveButton';

export default class Notifications extends Component {
    state = {
        isSaving: false,
        sms_appointment_reminder: 'disabled',
        sms_birthday_reminder: 'disabled',
        sms_birthday_template: '1',
        sms_template: '1',
        email_appointment_reminder: 'disabled',
        appointment_time: '1',
        sms_templates: []
    };

    getSMSTemplate = () => {
        let url = `${config.apiUrl}sms-templates`;

        axios.get(url).then((res) => {
            this.setState({
                sms_templates: res.data.data
            });
        }).catch((error) => {
            console.log(error);
        });
    };

    handleChange = (e) => {
        let data = {};
        data[e.target.id] = e.target.value;

        this.setState(data);
    };

    handleClick = () => {
        this.setState({
            isSaving: true
        });

        let data = {
            type: 'notifications',
            sms_appointment_reminder: this.state.sms_appointment_reminder,
            sms_birthday_reminder: this.state.sms_birthday_reminder,
            sms_template: this.state.sms_template,
            sms_birthday_template: this.state.sms_birthday_template,
            email_appointment_reminder: this.state.email_appointment_reminder,
            appointment_time: this.state.appointment_time
        };

        let url = `${config.apiUrl}settings`;

        axios.post(url, data).then((res) => {
            console.log(res);

            this.setState({
                isSaving: false
            });

            this.props.getSettings();
            this.props.showNotification('success', 'Settings Updated!');
        }).catch((error) => {
            console.log(error);

            this.setState({
                isSaving: false
            });

            this.props.showNotification('error', 'Failed to update settings');
        });
    };

    mapSettingsParameters = (settings) => {
        for (let setting of settings) {
            if (setting.type !== 'notifications') {
                continue;
            }

            let data = {};
            data[setting.param] = setting.value;

            this.setState(data);
        }
    };

    componentDidMount() {
        this.getSMSTemplate();
        this.mapSettingsParameters(this.props.settings);
    }

    componentWillReceiveProps(nextProps) {
        this.mapSettingsParameters(nextProps.settings);
    }

    render() {
        let showSMSReminderTemplate = '';
        let showSMSBirthdayTemplate = '';

        if (this.state.sms_appointment_reminder === 'disabled') {
            showSMSReminderTemplate = 'hide'
        }

        if (this.state.sms_birthday_reminder === 'disabled') {
            showSMSBirthdayTemplate = 'hide';
        }

        return (
            <div id="general_settings_container" ref="container">
                <div className="row">
                    <form action="">
                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="sms_appointment_reminder">
                                SMS Appointment Reminder
                                <br/>
                                <small>Send sms reminder to patients who scheduled an appointment</small>
                            </label>
                            <div className="col-md-10">
                                <select type="text" className="form-control"
                                        value={this.state.sms_appointment_reminder}
                                        onChange={this.handleChange}
                                        id="sms_appointment_reminder">

                                    <option value="enabled">Enabled</option>
                                    <option value="disabled">Disabled</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className={`form-group form-md-line-input col-md-12 col-lg-12 col-sm-12 ${showSMSReminderTemplate}`}>
                            <label className="col-md-2 control-label" htmlFor="sms_template">
                                SMS Appointment Reminder Template
                                <br/>
                                <small>Select the message template to be sent to clients</small>
                            </label>
                            <div className="col-md-10">
                                <select type="text" className="form-control"
                                        value={this.state.sms_template}
                                        onChange={this.handleChange}
                                        id="sms_template">

                                    {this.state.sms_templates.map((template, i) => {
                                        return (
                                            <option value={template.id} key={i}>{template.title}</option>
                                        )
                                    })}

                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="sms_birthday_reminder">
                                SMS Birthday Reminder
                                <br/>
                                <small>Send sms reminder to patients whose birthday is upcoming</small>
                            </label>
                            <div className="col-md-10">
                                <select type="text" className="form-control"
                                        value={this.state.sms_birthday_reminder}
                                        onChange={this.handleChange}
                                        id="sms_birthday_reminder">

                                    <option value="enabled">Enabled</option>
                                    <option value="disabled">Disabled</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className={`form-group form-md-line-input col-md-12 col-lg-12 col-sm-12 ${showSMSBirthdayTemplate}`}>
                            <label className="col-md-2 control-label" htmlFor="sms_birthday_template">
                                SMS Birthday Reminder Template
                                <br/>
                                <small>Select the message template to be sent to clients</small>
                            </label>
                            <div className="col-md-10">
                                <select type="text" className="form-control"
                                        value={this.state.sms_birthday_template}
                                        onChange={this.handleChange}
                                        id="sms_birthday_template">

                                    {this.state.sms_templates.map((template, i) => {
                                        return (
                                            <option value={template.id} key={i}>{template.title}</option>
                                        )
                                    })}

                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="email_appointment_reminder">
                                Email Appointment Reminder
                                <br/>
                                <small>Send email reminder to patients who scheduled an appointment</small>
                            </label>
                            <div className="col-md-10">
                                <select type="text" className="form-control"
                                        value={this.state.email_appointment_reminder}
                                        onChange={this.handleChange}
                                        id="email_appointment_reminder">

                                    <option value="enabled">Enabled</option>
                                    <option value="disabled">Disabled</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="appointment_time">
                                Appointment Reminder Time
                                <br/>
                                <small>How many day/s before sending the appointment reminder</small>
                            </label>

                            <div className="col-md-10">
                                <select type="file" className="form-control"
                                        value={this.state.appointment_time}
                                        onChange={this.handleChange}
                                        id="appointment_time">

                                    <option value="1">1 day before</option>
                                    <option value="2">2 days before</option>
                                    <option value="3">3 days before</option>
                                    <option value="4">4 days before</option>
                                    <option value="5">5 days before</option>
                                </select>
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <hr/>

                        <div className="form-actions col-md-12 col-lg-12 col-sm-12"
                             style={{ borderTop: '1px #eef1f5 solid', paddingTop: '20px' }}>
                            <div className="btn-set pull-right" style={{ width: '150px' }}>
                                <SaveButton name="Save" loadingName="Saving"
                                            onClickEvent={this.handleClick}
                                            isLoading={this.state.isSaving}
                                            type="button" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/settings/tabs/Notifications.js
 **/